//export const { url } = process.env.NODE_ENV === "development" ? dev : prod;

export const GenerateDynamicForm = "api/DynamicForm/GenerateForm";
export const ValidateDynamicFormFields =
  "api/DynamicForm/ValidateFormFieldsAsync";

export const getFormConfigDetails = "/DynamicForm/GenerateForm";
export const executeAction = "/DynamicForm/ExecuteAction";
export const getFormValues = "/DynamicForm/GetFormValues";
export const getDynamicFormTabs = "/DynamicForm/GetDynamicFormTabs";
export const getCascadeFieldOptions = "/DynamicForm/GetCascadeFieldOptions";
export const UploadFile = "/DynamicForm/UploadFile";

// Dynamic Report Api

export const generateReport = "/DynamicReport/GenerateReport";
export const fetchReportData = "/DynamicReport/FetchReportData";
export const fetchReportExcelData = "/DynamicReport/FetchReportExcelData";
export const executeReportAction = "/DynamicReport/ExecuteAction";

// Login Api
export const getAuthenticationConfig = "/Login/GetAuthenticationConfig";
export const userLogin = "/Login/UserLogin";
// export const userLogin = "/Login/OptimizedUserLogin";
export const getValidationMessages = "/Login/GetValidationMessages";
export const getForgotPassword = "/Login/ForgotPassword";
export const getPasswordExists = "/Login/GetPasswordExists";
export const generateTokenForAuthentication =
  "/Login/GenerateTokenForAuthentication";
export const getvalidateOtp = "/Login/ValidateOTP";
export const getRefreshtoken = "/Auth/Refresh";
export const getAuthenticationType = "/Login/GetAuthenticationType";
export const userLogout = "/Login/LogoutUser";

// Added a common method for the getting the authconfig data.
export const getConfigData = "/Auth/GetConfigData";

//ConfigurationMaster
export const getDropdowns = "/ConfigurationMaster/GetDropdowns";

//User access emp dropdown from azure AD
export const getEmployeeDropdownUserAccess = "/Common/GetAzureADUser";
export const insertUpdatePOIConfiguration = "/ConfigurationMaster/InsertUpdatePOIConfiguration";
export const deletePOIConfiguration = "/ConfigurationMaster/DeletePOIConfiguration";
export const deletePOIAdditionalField = "/ConfigurationMaster/DeletePOIAdditionalField";

//EmployeeMaster lock/unlock
export const executeLockUnlock = "/EmployeeMaster/ExecuteLockUnlock"
export const getPOIConfigurationById = "/ConfigurationMaster/GetConfigurationDataById";

//Employee General Info
export const getEmpGeneralInfo = "/Common/GetEmpGeneralInfo";

//POIDeclaration
export const fetchInvestmentCycles = "/VerificationPOI/GetInvestmentCycles"
export const fetchPOIDeclarationData = "/VerificationPOI/GetPOIDeclarationData"
export const fetchPOISubmissionData = "/VerificationPOI/GetPOISubmissionData"
export const fetchUserList = "/VerificationPOI/GetUserListData"
export const assignPoiVerification = "/VerificationPOI/AssignVerification"
export const fetchVerificationData = "/VerificationPOI/GetVerificationData"

//EmployeeDashboard
export const getCategoryForDeclaration = "/EmployeeDashboard/GetCategoryListForDeclarations";
export const getSectionForDeclaration = "/EmployeeDashboard/GetSectionListForDeclarations";
export const insertUpdateEmployeeDeclarations = "/EmployeeDashboard/InsertUpdateEmployeeDeclarations";
export const deleteEmployeeDeclarationDetails = "/EmployeeDashboard/DeleteEmployeeDeclarationDetails";
export const visibilityOfPreviousEmployerSalaryTab = "/EmployeeDashboard/VisibilityOfPreviousEmployerSalaryTab";

//Investment Submission
export const GetSectionComponentData = "/EmployeeDashboard/GetSectionComponentData";
export const GetDocumentTypeData = "/EmployeeDashboard/GetDocumentTypeData";
export const GetAdditionalFields = "/EmployeeDashboard/GetAdditionalFields";
export const SaveSubmissionData = "/EmployeeDashboard/SaveSubmissionData";
export const DeleteSubmissionData = "/EmployeeDashboard/DeleteSubmissionData";

//Query on chat icon
export const getQueryOnChat = "/EmployeeQuery/GetEmployeeQueryOnChat";
export const insertNewMsgOfEmp = "/EmployeeQuery/InsertForEmployeeChat";
export const msgCountForEmp = "/EmployeeQuery/NotificationCountForEmp";
export const updateIsReadFlagForEmp = "/EmployeeQuery/UpdateIsReadForEmp";
export const insertForVerifierChat = "/EmployeeQuery/InsertForVerifierChat";

//Form 12 BB
export const empFormData = "/EmployeeQuery/EmpInfoForForm";
export const getFormData = "/FormData/GetFormDatas";

//Allowance Tab 
export const GetSectionComponentDataAllowance = "/EmployeeDashboard/GetSectionComponentDataForAllowance";
export const GetDocumentTypeDataAllowance = "/EmployeeDashboard/GetDocumentTypeForAllowance";
export const GetAdditionalFieldsAllowance = "/EmployeeDashboard/GetAdditionalFieldsAllowance";
export const visibilityOfAllowanceTab = "/EmployeeDashboard/VisibilityOfAllowanceTab";
export const docToShowOnAllowanceTab = "/EmployeeDashboard/DocShowOfAllowanceTab";
export const visibilityOfITDeclarationTab = "/EmployeeDashboard/VisibilityOfITDeclarationTab";


//VerificationDashboard
export const getInvestmentCycleForVerification = "/VerificationDashboard/GetInvestmentCycleDataForVerification";
export const getAdditionalFieldsForVerification = "/VerificationDashboard/GetAdditionalFields";
export const updateVerificationAction = "/VerificationDashboard/UpdateVerificationAction";
export const viewFile = "/VerificationDashboard/ViewFile";
export const updateEmployeeSubmissionFinalDetails = "/VerificationDashboard/UpdateEmployeeSubmissionFinalDetails";
export const fetchAllDocofEmployee = "/VerificationDashboard/GetAllDocOfEmployee"

//Report Request Dashboard
export const getDropdownsForReport = "/ReportRequest/GetDropdownsForReport";
export const downloadReport =  "/ReportRequest/DownloadReport";
export const getReportRequestDashboardData =  "/ReportRequest/GetReportRequestDashboardData";
export const getFileData =  "/ReportRequest/GetFileData";





